export default "__VITE_ASSET__DAaKEdqO__"